export const TABLE_EVENTS = {
  DATA_LOADED: 'table-data-loaded', // 表格数据请求获取成功
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/config/events.js